module.exports = __webpack_public_path__ + "media/vans/yellow-van-0138758f.svg";